module.exports = __webpack_public_path__ + "static/media/title_bg_2.8b470d04.png";